import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const CheckPackage = (props) => {
  const [loading, setLoading] = useState(true);
  const [packageX, setPackageX] = useState("");

  const getInfo = async (e) => {
    var body = {
      guid: props.num,
    };

    fetch("https://apidevkppp.ftpeople.pl/getTracking", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (+data.return.status === -1) {
          MySwal.fire({
            icon: "success",
            title: "Nie udało się znaleźć statusu przesyłki",
          }).then(async (result) => {
            setLoading(false);
            props.close();
          });
        } else {
          if (data.return.danePrzesylki.zdarzenia !== undefined) {
            setPackageX(
              data.return.danePrzesylki.zdarzenia.zdarzenie.sort(function (
                a,
                b
              ) {
                return new Date(b.czas) - new Date(a.czas);
              })[0]
            );
            setLoading(false);
          } else {
            MySwal.fire({
              icon: "success",
              title: "Nie udało się znaleźć statusu przesyłki",
            }).then(async (result) => {
              setLoading(false);
              props.close();
            });
          }
        }
      });
  };

  const getData = () => {
    setLoading(true);
    getInfo();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div style={{ width: "40vw" }} className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>
          <p>
            Data ostatniej zmiany statusu:{" "}
            {packageX ? packageX.czas : "brak danych"}
          </p>
          <p>Status: {packageX ? packageX.nazwa : "brak danych"}</p>
          <p>
            Koniec obsługi:{" "}
            {packageX ? (packageX.konczace ? "TAK" : "NIE") : "brak danych"}
          </p>
        </>
      )}
    </div>
  );
};

export default CheckPackage;
